<template>
  <header class="header">
    <BackButton class="header__back" />

    <router-link class="header__title" to="/">School Log</router-link>

    <HeaderNav class="header__nav" />
  </header>
</template>

<script>
import BackButton from '@/components/BackButton'
import HeaderNav from '@/components/HeaderNav'

export default {
  name: 'AppHeader',

  components: {
    BackButton,
    HeaderNav
  }
}
</script>

<style lang="scss">
.header {
  padding: .5rem 1rem;
  display: grid;
  grid-template: "back title nav" auto / 1fr max-content 1fr;
  align-items: center;
}

.header__back {
  grid-area: back;
  justify-self: start;
}

.header__title {
  grid-area: title;
  font-size: 2rem;
  font-weight: 750;
  text-decoration: none;
}

.header__nav {
  grid-area: nav;
  justify-self: end;
}
</style>
